import React, { useEffect, useState } from 'react';
import { useFCMContext } from '../FCMProvider/FCMProvider';
import {
  isWebNotificationPromptNeeded,
  primeWebNotificationPermission
} from '../../utils/webNotificationPermission';
import './PushEnableBar.scss';

const DISMISS_KEY = 'zeedcom_push_bar_dismissed';

const PushEnableBar: React.FC = () => {
  const { registerToken } = useFCMContext();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem(DISMISS_KEY)) return;
    } catch {
      return;
    }
    setVisible(isWebNotificationPromptNeeded());
  }, []);

  if (!visible) return null;

  const hide = () => {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // Private mode can block storage.
    }
    setVisible(false);
  };

  const enable = async () => {
    const permission = await primeWebNotificationPermission();
    if (permission === 'granted') {
      await registerToken().catch(() => {});
    }
    hide();
  };

  return (
    <div className="push-enable-bar" role="status">
      <span>Notifications</span>
      <div className="push-enable-bar__actions">
        <button type="button" onClick={enable}>Activer</button>
        <button type="button" className="push-enable-bar__skip" onClick={hide}>Plus tard</button>
      </div>
    </div>
  );
};

export default PushEnableBar;
